import React from 'react';
import { Stepper, Step, StepLabel, Typography, Paper, styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LensIcon from '@mui/icons-material/Lens';

const GreenStepIcon = styled('span')(({ theme }) => ({
    color: theme.palette.success.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const BlueStepIcon = styled('span')(({ theme }) => ({
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const GrayStepIcon = styled('span')(({ theme }) => ({
    color: theme.palette.grey[400],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

function CustomStepIcon(props) {
    const { status } = props;
    if (status === 'completed') {
        return (
            <GreenStepIcon>
                <CheckIcon />
            </GreenStepIcon>
        );
    }
    if (status === 'active') {
        return (
            <BlueStepIcon>
                <LensIcon />
            </BlueStepIcon>
        );
    }
    return (
        <GrayStepIcon>
            <RadioButtonUncheckedIcon />
        </GrayStepIcon>
    );
}

const WorkflowStages = ({ stages, history = [], currentStage, onStageClick }) => {
    const historyIds = new Set((history || []).map(s => s.id));
    const initialStage = stages && stages.length > 0 ? stages.find(s => s.is_initial) : null;
    const effectiveCurrentStage = currentStage || initialStage;

    const getStageStatus = (stage) => {
        // If this is the effective current stage (either actual current or initial)
        if (stage.id === effectiveCurrentStage?.id) return 'active';
        // If this stage is in history, it's completed
        if (historyIds.has(stage.id)) return 'completed';
        // Otherwise it's pending
        return 'pending';
    };

    return (
        <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
                Service Order Workflow
            </Typography>
            <Stepper alternativeLabel activeStep={stages.findIndex(s => s.id === effectiveCurrentStage?.id)}>
                {stages.map((stage) => {
                    const status = getStageStatus(stage);
                    const isCurrent = stage.id === effectiveCurrentStage?.id;
                    return (
                        <Step key={stage.id} completed={status === 'completed'}>
                            <StepLabel
                                StepIconComponent={() => <CustomStepIcon status={status} />}
                                onClick={() => onStageClick && onStageClick(stage)}
                                sx={{ cursor: onStageClick ? 'pointer' : 'default' }}
                            >
                                <Typography variant="body2">{stage.name}</Typography>
                                {isCurrent && (
                                    <Typography variant="caption" color="primary" sx={{ fontWeight: 'bold' }}>
                                        (Current Stage)
                                    </Typography>
                                )}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Paper>
    );
};

export default WorkflowStages; 